/* sp-story.js: a Story Path story as a cloth-bound book in the books reader (Z-stories, 2 Nov 2026).
   Inside: assets/books-shelf.js lines 740-1138 (the live reader: turning, curl, drag, keys), unchanged, between the markers.
   Everything else is the story surface: pages built from the article the server printed, the cover, the build page,
   "Make this story for me" (/cart/add.js then /checkout), the free story by email, motes, sparkles and the unicorn.
   One function scope: nothing is added to window. */
(function(){
var dataEl=document.getElementById('spStoryData'), osbEl=document.getElementById('osb'); if(!dataEl||!osbEl) return;
var D=JSON.parse(dataEl.textContent);
var spReduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
function tpl(id){ var t=document.getElementById(id); return t?t.innerHTML:''; }
var ORN='<svg class="orn" viewBox="0 0 200 20" aria-hidden="true"><path d="M2 10 H80 M120 10 H198 M100 3 L107 10 L100 17 L93 10 Z M86 10 a4 4 0 1 0 8 0 a4 4 0 1 0 -8 0 M106 10 a4 4 0 1 0 8 0 a4 4 0 1 0 -8 0"/></svg>';
var ORN2='<svg class="orn" viewBox="0 0 200 20" aria-hidden="true"><path d="M2 10 H80 M120 10 H198 M100 3 L107 10 L100 17 L93 10 Z"/></svg>';
/* ---- the book's pages, from the article the server printed (the text stays in the HTML for Google and for anyone without scripts) ---- */
var interior=[];
Array.prototype.forEach.call(document.querySelectorAll('#spStoryText .sp-story-page'),function(s,n){
  var fig=s.querySelector('.sp-story-fig');
  var paras=Array.prototype.map.call(s.querySelectorAll('p'),function(p,j){ return '<p'+(n===0&&j===0?' class="drop"':'')+'>'+p.innerHTML+'</p>'; }).join('');
  interior.push({html:'<div class="sp-art">'+(fig?fig.innerHTML:'')+'<span class="cap">'+esc(s.getAttribute('data-name')||'')+'</span></div>'});
  interior.push({html:'<div class="sp-text">'+paras+'<span class="pno">'+(n+1)+'</span></div>'});
});
/* the poem: one verse per spread, on the same drawing as the prose spread */
var interiorPoem=[]; var verses=document.querySelectorAll('#spStoryPoem .sp-poem-page');
if(D.hasPoem && verses.length){ Array.prototype.forEach.call(verses,function(v,n){ if(n*2>=interior.length) return; var p=v.querySelector('.verse'); interiorPoem.push(interior[n*2]); interiorPoem.push({html:'<div class="sp-text verse"><p>'+(p?p.innerHTML:'')+'</p><span class="pno">'+(n+1)+'</span></div>'}); }); }
var spMode='story';
var BOOKS={}; BOOKS[D.handle]={t:D.title, a:'A Story Path story', pub:'Oak & Sprout', type:D.kindLine, d:'', detail:'', jbg:'#22301f', ar:'3/4', interior:interior, shelf_caption:'', price:D.price, rrp:'', story:true, tiles:D.tiles, edition_group:''};
/* ---- stubs for the shop-only helpers the reader calls ---- */
function osbCountTurn(){} function osbPrewarm(){} function osbReaderReady(f){ f(); } function applyRatio(){}
function isBox(){ return false; } function jacketClass(){ return ''; } function osbWithArticle(n){ return n; }
function syncUrl(){} function osbTrackOpen(){}
function osbPairMediaHTML(){ return ''; } function osbPairInfoHTML(){ return ''; }
function osbCartAdd(b, both, btn){ spMakeIt(btn); }
function openBook(key){ openBookCore(key); } function closeBook(){ closeBookCore(); spClosed(); }
/* ===== live reader code, assets/books-shelf.js lines 740-1138, unchanged ===== */
const panel = document.getElementById('panel');
const live  = document.getElementById('live');
let lastFocus = null;

const bookOpen  = document.getElementById('bookOpen');
const leaf      = document.getElementById('leaf');
const leafFront = document.getElementById('leafFront');
const leafBack  = document.getElementById('leafBack');
const pgLeft    = document.getElementById('pgLeft');
const pgRight   = document.getElementById('pgRight');
const pTurn     = document.getElementById('pTurn');
const pBack     = document.getElementById('pBack');

/* ---------- the pages of one book ----------
   [cover] [what it is] [every page from the spread packs] [why it's on our shelf]
   The last page is the reason and the pairing, so turning through the book ends on
   us rather than opening on us. */
/* A book cover is portrait and the page is portrait, so it bleeds to the edge and is
   the page. A box lid is landscape: bleeding it into a portrait page crops the lid to
   its middle third and throws away both ends of the artwork. So anything landscape sits
   ON the page instead, centred with its own shadow — the same rule as the interior
   photographs. Keyed off `kind` today because every book here is portrait; the real
   test is orientation, so a landscape book cover would want this path too. */
/* Every image page is the same thing; whether it bleeds or sits on the paper is
   decided from its natural aspect at load, not from what kind of product it is. A
   scanned book page matches the page and fills it; a product photograph, even trimmed
   to its bounding box, usually doesn't, and cropping one to fit throws away the ends
   of it. Same idea as applyRatio on the shelf: measure the image, don't assume.

   A box's flat lid stays on the shelf, where face-on is right for something standing
   up; the reader opens on covPage, the product shot. */
function imgPage(src, alt){
  return '<div class="page-img"><img src="' + src + '" alt="' + (alt || '') + '"></div>';
}
function coverPage(b){
  const src = b.covPage || b.cov;
  if(src) return imgPage(src, b.t);
  return '<div class="page-inner pg-cover"><span class="jacket' + jacketClass(b) +
    '" style="--ar:' + (b.ar || '3/4') + ';background:' + b.jbg + '"><span></span><span class="j-t">' + b.t +
    '</span><span class="j-a">' + b.a + '</span></span></div>';
}
/* Two voices, and both earn their place. `d` is ours — short, why it's on this shelf.
   `blurb` is the publisher's own selling copy from the feed's description field, which
   someone was paid to write about this exact book. Ours reads as a standfirst, theirs
   as the body under it. */
function aboutPage(b){
  const blurb = b.blurb
    ? '<div class="pg-blurb"><span class="eyebrow">From the publisher</span><p>' +
      b.blurb + '</p></div>'
    : '';
  return '<div class="page-inner about-page">' +
    '<span class="pg-chip">' + b.type + (b.detail ? ' · ' + b.detail : '') + '</span>' +
    '<div class="pg-title">' + b.t + '</div>' +
    '<div class="pg-by">' + b.a + ' · ' + b.pub + '</div>' +
    '<p class="pg-stand">' + b.d + '</p>' + blurb + '</div>';
}
function insidePage(src){ return imgPage(src); }
function blankPage(b){
  return '<div class="page-inner"><div class="page-epigraph"><p>' + b.shelf_caption + '</p></div></div>';
}
/* The closing page is the paired toy, given a whole page rather than a box in the
   corner of an empty one. In Liquid the media area is the theme's own product card —
   {% render 'card-product', card_product: pairing %} — so the image, price and badges
   come from Shopify and stay in step with the product. Here it's a marked slot.

   The card is not itself a link. Tap-to-turn means a page-sized click target would
   send anyone flicking through straight to a product page; the small CTA is the only
   thing that navigates. */
const ADDON_EXTRA = 25;   /* % off the book when a toy goes in the same basket */

function whyPage(b){
  const reason = b.pairing_reason ? b.pairing_reason.charAt(0).toUpperCase() + b.pairing_reason.slice(1)
                     : 'It is here for one reason: we would keep it ourselves.';
  const card = b.pairing_name
    ? '<div class="prod-card">' +
        osbPairMediaHTML(b) +
        '<div class="pc-body">' +
          '<span class="pc-eyebrow">Made to go together</span>' +
          '<span class="pc-name">' + b.pairing_name + '</span>' +
          osbPairInfoHTML(b) +
          '<div class="pc-buy">' +
            '<button class="btn" data-both="' + b.pairing_name + '">Add both</button>' +
            '<button class="btn btn-quiet" data-only="1">Just the book · ' + b.price + '</button>' +
          '</div>' +
          '<p class="pg-offer">Buy the toy and the book together and take a further ' +
          ADDON_EXTRA + '% off the book, automatically added in cart.</p>' +
          '<a class="pc-cta" href="' + b.pairing_url + '">Engraving is free \u2014 add it on ' +
          osbWithArticle(b.pairing_name) + ' page &rsaquo;</a>' +
        '</div>' +
      '</div>'
    : '';
  return '<div class="page-inner why-page">' +
    '<div class="pg-kicker">Why it\u2019s on our shelf</div>' +
    '<div class="pg-why">' + reason + '</div>' + card + '</div>';
}
function buildPages(b){
  const p = [coverPage(b), aboutPage(b)];
  const inside = b.interior || [];
  inside.forEach(src => p.push(insidePage(src)));
  /* a book always opens onto something; a box doesn't have pages to open at all */
  if(!inside.length && !isBox(b)) p.push(blankPage(b));
  p.push(whyPage(b));
  return p;
}

/* ---------------- turning ----------------
   i is the index of the page on the leaf's front.
   Two-up: the leaf holds the right-hand page, so i is odd and a turn moves two.
   One-up: the leaf is the whole page, so a turn moves one. */
let PAGES = [], i = 0, turning = false, currentKey = null;
/* A page's shape, taken from the opening image. 0.757 only until one loads. */
let pageAR = 0.757;

/* Two pages side by side only for a portrait book. A landscape one is already wide;
   opening it as a spread would give a 2.9:1 letterbox 300px tall. */
const twoUp = () => window.innerWidth > 1000 && pageAR < 1 && !(currentKey && BOOKS[currentKey].one_up);

function applyShape(){
  bookOpen.style.setProperty('--ratio', (twoUp() ? pageAR * 2 : pageAR).toFixed(4));
  bookOpen.classList.toggle('one-up', !twoUp());
}
const step  = () => twoUp() ? 2 : 1;
const first = () => twoUp() ? 1 : 0;
const at = n => (n >= 0 && n < PAGES.length) ? PAGES[n] : '';

function dim(el){ el.querySelectorAll('a,button').forEach(x => x.tabIndex = -1); }

/* Fill the page when the image is close to the page's own shape; sit on it when it
   isn't. 12% either way, so a small mismatch still crops (nobody misses two percent
   of an edge) while a real one is left whole. */
function fitPage(img){
  const box = img.parentElement.getBoundingClientRect();
  if(!box.height || !img.naturalHeight) return;
  const off = (img.naturalWidth / img.naturalHeight) / (box.width / box.height);
  img.parentElement.classList.toggle('contain', off > 1.12 || off < 0.89);
}
function fitPages(){
  document.querySelectorAll('#bookOpen .page-img img').forEach(img=>{
    if(img.complete) fitPage(img); else img.addEventListener('load',()=>fitPage(img),{once:true});
  });
}

const zoneNext = document.getElementById('zoneNext');

function render(){
  leafFront.innerHTML = at(i);
  leafBack.innerHTML  = at(i + 1);
  pgLeft.innerHTML    = twoUp() ? at(i - 1) : '';
  pgRight.innerHTML   = at(i + 1);      /* one-up: the page under the one on top */
  fitPages();
  dim(leafBack);                        /* facing away — keep it out of the tab order */
  leaf.classList.add('no-anim');
  leaf.style.transform = 'rotateY(0deg)';
  void leaf.offsetWidth;
  leaf.classList.remove('no-anim');
  const noFwd = i + 1 >= PAGES.length, noBack = i - step() < first();
  pTurn.disabled = noFwd;
  pBack.disabled = noBack;
  zoneNext.hidden = noFwd;
  bookOpen.classList.toggle('at-end', noFwd);   /* nothing under it, so don't cut it */
  document.getElementById('rbCount').textContent =
    Math.min(i + 1, PAGES.length) + ' / ' + PAGES.length;
}

const settle = (next, done) => {
  const end = () => { leaf.removeEventListener('transitionend', end); i = next; render(); done && done(); };
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){ i = next; render(); turning = false; return; }
  leaf.addEventListener('transitionend', end);
};

const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const DUR = 620;

/* Put the right content on the right surfaces for a turn in this direction, and
   return the index we'd land on. Null means there's nowhere to go. */
function prep(dir){
  const next = i + dir * step();
  if(dir > 0 && i + 1 >= PAGES.length) return null;
  if(dir < 0 && next < first()) return null;
  if(twoUp()){
    if(dir > 0){ leafBack.innerHTML = at(i + 1); pgRight.innerHTML = at(i + 2); }
    else { leafFront.innerHTML = at(next); leafBack.innerHTML = at(next + 1);
           pgLeft.innerHTML = at(next - 1); pgRight.innerHTML = at(i + 1); }
  } else {
    if(dir > 0) pgRight.innerHTML = at(i + 1);
    else { leafFront.innerHTML = at(next); pgRight.innerHTML = at(i); }
  }
  return next;
}

/* One animation per layout, played forwards or in reverse — a backward turn is
   just the forward one unwound. Because it's an animation rather than a transition,
   a negative delay on a paused animation seeks it, which is what lets a drag scrub
   the turn frame by frame instead of only triggering it. */
function setAnim(dir, p, paused){
  leaf.style.animationName = twoUp() ? 'osbFlip' : 'osbTuck';
  leaf.style.animationDuration = DUR + 'ms';
  leaf.style.animationTimingFunction = 'linear';
  leaf.style.animationFillMode = 'forwards';
  leaf.style.animationDirection = dir > 0 ? 'normal' : 'reverse';
  leaf.style.animationDelay = (-p * DUR) + 'ms';
  leaf.style.animationPlayState = paused ? 'paused' : 'running';
}
function clearAnim(){ leaf.style.animation = ''; leaf.style.animationPlayState = ''; }
function commit(next){
  clearAnim(); bookOpen.classList.remove('turning','lit');
  i = next; render(); turning = false;
  osbCountTurn(i, PAGES.length);
}

function turnLeaf(dir){
  if(turning) return;
  const next = prep(dir);
  if(next === null) return;
  turning = true;
  bookOpen.classList.add('turning');
  if(reduced()){ commit(next); return; }
  setAnim(dir, 0, false);
  leaf.addEventListener('animationend', function done(){
    leaf.removeEventListener('animationend', done); commit(next);
  });
}

/* ---------- drag ----------
   The page follows the finger; let go past a third of the way and it completes,
   short of that and it goes back. Snapping back is the same animation played the
   other way from wherever the finger left it. */
let drag = null;
function dragSpan(){ return bookOpen.getBoundingClientRect().width * (twoUp() ? .5 : .85); }

bookOpen.addEventListener('pointerdown', e=>{
  if(turning || e.target.closest('a,button')) return;
  drag = {x:e.clientX, y:e.clientY, live:false, p:0, dir:0, next:null, moved:false};
});
bookOpen.addEventListener('pointermove', e=>{
  if(!drag) return;
  const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
  if(!drag.live){
    if(Math.abs(dx) < 9 || Math.abs(dx) < Math.abs(dy)) return;
    drag.dir = dx < 0 ? 1 : -1;
    drag.next = prep(drag.dir);
    if(drag.next === null){ drag = null; return; }
    drag.live = true; drag.moved = true; turning = true;
    bookOpen.classList.add('turning');
  }
  drag.p = Math.max(0, Math.min(1, (drag.dir > 0 ? -dx : dx) / dragSpan()));
  setAnim(drag.dir, drag.p, true);
});
function endDrag(){
  if(!drag) return;
  const d = drag; drag = null;
  if(!d.live) return;
  const finish = () => {
    leaf.addEventListener('animationend', function done(){
      leaf.removeEventListener('animationend', done);
      if(d.p > .3) commit(d.next);
      else { clearAnim(); bookOpen.classList.remove('turning'); render(); turning = false; }
    });
  };
  if(d.p > .3){ setAnim(d.dir, d.p, false); }
  else { setAnim(-d.dir, 1 - d.p, false); }   /* unwind from where they let go */
  finish();
}
bookOpen.addEventListener('pointerup', endDrag);
bookOpen.addEventListener('pointercancel', endDrag);

/* ---------- tap the page ---------- */
bookOpen.addEventListener('click', e=>{
  if(e.target.closest('a,button')) return;
  if(turning) return;
  const pairMedia = e.target.closest('.pc-media[data-href]');
  if(pairMedia){ location.href = pairMedia.getAttribute('data-href'); return; }
  const r = bookOpen.getBoundingClientRect();
  const x = (e.clientX - r.left) / r.width;
  turnLeaf(x < (twoUp() ? .5 : .32) ? -1 : 1);
});

/* Other editions of the same title: same `grp`, different binding. Clicking one
   opens that edition's own reader, so the page count and the interior pages come
   with it rather than only the price changing. */
const readerAlts = document.getElementById('readerAlts');
const raList = document.getElementById('raList');
function renderAlts(key){
  const grp = BOOKS[key].edition_group;
  const sibs = grp ? Object.keys(BOOKS).filter(k => BOOKS[k].edition_group === grp && k !== key) : [];
  readerAlts.hidden = !sibs.length;
  raList.innerHTML = sibs.map(k => {
    const s = BOOKS[k];
    const img = s.cov ? '<img src="' + s.cov + '" alt="">' : '';
    return '<button class="ra-item" data-alt="' + k + '">' + img +
      '<span><span class="ra-bind">' + s.type + '</span>' +
      '<span class="ra-price' + (s.rrp ? '' : ' no-rrp') + '">' +
      (s.rrp ? '<s>' + s.rrp + '</s>' : '') + '<b>' + s.price + '</b></span></span></button>';
  }).join('');
  raList.querySelectorAll('[data-alt]').forEach(el =>
    el.addEventListener('click', () => openBook(el.dataset.alt, false, 'edition')));
}

/* ---------- open and close ---------- */
function openBookCore(key){ osbReaderReady(function(){ osbPrewarm(key); osbOpenBookNow(key); }); }
function osbOpenBookNow(key){
  const b = BOOKS[key]; if(!b) return;
  /* shape the reader before anything is measured in it.
     NB: not `first` — that's the function giving the starting page index. */
  const opening = b.covPage || b.cov;
  pageAR = 0.757;
  if(opening){
    const probe = new Image();
    probe.onload = () => {
      pageAR = probe.naturalWidth / probe.naturalHeight;
      applyShape(); render();
    };
    probe.src = opening;
    if(probe.complete && probe.naturalWidth){ pageAR = probe.naturalWidth / probe.naturalHeight; }
  }
  applyShape();
  /* switching edition shouldn't overwrite where we came from */
  if(!panel.classList.contains('open')) lastFocus = document.activeElement;
  currentKey = key;
  PAGES = buildPages(b);
  i = first();
  document.getElementById('rbTitle').textContent = b.t;
  document.getElementById('rbBind').textContent = b.type;
  const rbPriceEl = document.getElementById('rbPrice');
  rbPriceEl.className = 'rb-price' + (b.rrp ? '' : ' no-rrp');
  rbPriceEl.innerHTML = (b.rrp ? '<s>' + b.rrp + '</s> ' : '') + '<b>' + b.price + '</b>';
  renderAlts(key);
  render();
  const img = leafFront.querySelector('.jacket img.cov-img') || pgLeft.querySelector('.jacket img.cov-img');
  if(img){ if(img.complete) applyRatio(img); else img.addEventListener('load',()=>applyRatio(img)); }
  panel.classList.add('open');
  document.body.style.overflow = 'hidden';
  panel.querySelector('.closex').focus();
}
function closeBookCore(){
  panel.classList.remove('open');
  document.body.style.overflow = '';
  if(lastFocus) lastFocus.focus();
}
pTurn.addEventListener('click',()=>turnLeaf(1));
pBack.addEventListener('click',()=>turnLeaf(-1));
/* the corner lifts on hover or keyboard focus — the cut and the flap grow together */
const lift = on => bookOpen.classList.toggle('lit', on);
zoneNext.addEventListener('pointerenter',()=>lift(true));
zoneNext.addEventListener('pointerleave',()=>lift(false));
pTurn.addEventListener('focus',()=>lift(true));
pTurn.addEventListener('blur', ()=>lift(false));
document.getElementById('rbAdd').addEventListener('click',e=>{
  if(currentKey) osbCartAdd(BOOKS[currentKey], false, e.currentTarget);
});

/* Both buttons are ordinary cart adds — one line item or two. The discount is a
   native Shopify Buy X Get Y (any product on the toy list, one book from the book
   list), so it applies in the cart on its own. Nothing here calculates a price, and
   a customer who already has a toy in the basket gets the same thing from the plain
   button. In Liquid this is /cart/add.js with items[].

   Engraving is a line item property rather than a variant, so adding with no
   properties adds the plain toy and no choice has to be made here. That is the point:
   one decision, not three. The cost is that someone who would have engraved never gets
   asked, and properties can't be edited once a line is in the cart — hence the link
   below the buttons, which exists to carry that rather than to be a generic "view
   product". Note also that the same toy added later WITH engraving becomes a second
   line item, not a quantity of the first. */
bookOpen.addEventListener('click', e=>{
  const both = e.target.closest('[data-both]');
  const only = e.target.closest('[data-only]');
  if(!both && !only) return;
  e.stopPropagation();                       /* don't also turn the page */
  const b = BOOKS[currentKey];
  osbCartAdd(b, !!both, both || only);
});
/* the page count changes when the layout does, so re-seat the index */
window.addEventListener('resize', ()=>{
  if(!panel.classList.contains('open')) return;
  applyShape();
  if(twoUp() && i % 2 === 0) i = Math.max(first(), i - 1);
  if(!twoUp() && i < 0) i = 0;
  render();
});

/* ---------- close, keys, focus ---------- */
document.querySelectorAll('[data-close]').forEach(el=>el.addEventListener('click',()=>closeBook()));
document.addEventListener('keydown',e=>{
  if(!panel.classList.contains('open')) return;
  if(e.key === 'Escape'){ closeBook(); return; }
  if(e.key === 'ArrowRight'){ e.preventDefault(); turnLeaf(1); return; }
  if(e.key === 'ArrowLeft'){ e.preventDefault(); turnLeaf(-1); return; }
  if(e.key !== 'Tab') return;
  /* keep focus inside the reader while it is open */
  const f = [...panel.querySelectorAll('button,a[href],[tabindex]:not([tabindex="-1"])')]
              .filter(el => el.offsetParent !== null && !el.disabled);
  if(!f.length) return;
  /* firstEl/lastEl, not first/last — `first` is the function giving the opening page */
  const firstEl = f[0], lastEl = f[f.length - 1];
  if(e.shiftKey && document.activeElement === firstEl){ e.preventDefault(); lastEl.focus(); }
  else if(!e.shiftKey && document.activeElement === lastEl){ e.preventDefault(); firstEl.focus(); }
});

/* ===== end of the live reader code ===== */

/* ---- story pages in the same reader ---- */
function insidePage(x){ return (x && x.html) ? '<div class="page-inner" style="padding:0">' + x.html + '</div>' : imgPage(x); }
var spPat=(function(){ var sc=tpl('spPatScene'); if(!sc) return 'none'; var s='<svg xmlns="http://www.w3.org/2000/svg" viewBox="-12 -8 176 142"><g fill="none" stroke="#b08a4e" stroke-width="1" stroke-opacity=".55">'+sc+'</g></svg>'; return 'url("data:image/svg+xml;utf8,'+encodeURIComponent(s)+'")'; })();
function spEndpaper(plate){ return '<div class="page-inner" style="padding:0"><div class="sp-end" style="--pat:'+spPat+'">'+(plate?'<div class="sp-plate"><div class="ex">EX LIBRIS</div><div class="bel">This book belongs to</div><div class="who" aria-hidden="true"></div>'+tpl('spPlateArt')+'</div>':'')+'</div></div>'; }
function spTitlePage(b){ var link=interiorPoem.length?'<a href="#" class="sp-modelink">'+(spMode==='poem'?'Read it as a story ›':'Read it as a poem ›')+'</a>':''; return '<div class="page-inner" style="padding:0"><div class="sp-titlepg">'+ORN+'<h1>'+esc(b.t)+'</h1><div class="sub">'+D.subtitle+'</div>'+ORN2+link+'<div class="imp">Oak &amp; Sprout · Wiltshire</div></div></div>'; }
function spSetMode(mode){ if(!interiorPoem.length) return; spMode=mode==='poem'?'poem':'story'; var b=BOOKS[D.handle]; b.interior=spMode==='poem'?interiorPoem:interior; b.type=spMode==='poem'?D.kindLine.replace(/^Bedtime \w+/,'Bedtime poem'):D.kindLine;
  var mb=document.getElementById('spMode'); if(mb){ mb.setAttribute('aria-pressed',spMode==='poem'?'true':'false'); mb.textContent=spMode==='poem'?'Read it as a story':'Read it as a poem'; }
  document.getElementById('rbBind').textContent=b.type;
  if(currentKey){ PAGES=buildPages(b); render(); var r=spBook.getBoundingClientRect(); spBurst(r.left+r.width/2, r.top+r.height/2, 18); }
  spTrack('sp_story_mode',{story:D.handle,mode:spMode}); }
var modeBtn=document.getElementById('spMode'); if(modeBtn) modeBtn.addEventListener('click',function(){ spSetMode(spMode==='poem'?'story':'poem'); });
function spTheEnd(){ return '<div class="page-inner" style="padding:0"><div class="sp-theend">'+ORN+'<div class="word">The End</div>'+ORN2+'</div></div>'; }
/* ---- the free-story email's link (stories lead ads, 2 Nov 2026): ?st= is an opaque token the server reads to know the
   address; it is posted back in place of an email and is never shown. The name is typed here, or suggested as in the game. ---- */
var spST=null; try{ var spM=location.search.match(/[?&]st=([^&#]+)/); if(spM) spST=decodeURIComponent(spM[1]); }catch(e){}
var SP_NAMES=["Olivia","Amelia","Lily","Isla","Ivy","Muhammad","Noah","Oliver","Arthur","Leo","Little Bear","Bramble","Sir Pip","Wren","Captain Oak"], SP_STORY_NAMES={"Little Bear":1,"Bramble":1,"Sir Pip":1,"Wren":1,"Captain Oak":1}, spSugHist=[];   /* the game's list and rules (sp-page.js, 1 Nov) */
var SP_LINK='all:unset;cursor:pointer;justify-self:start;font-family:"Cormorant Garamond",Georgia,serif;font-style:italic;font-size:clamp(12px,1.9cqh,15px);color:#7a5524;border-bottom:1px dotted rgba(122,85,36,.5)';
function spSuggest(f){ var el=f.querySelector('[name=child]'), cur=(el.value||'').trim(), last4=spSugHist.slice(-4), lastStory=spSugHist.length&&SP_STORY_NAMES[spSugHist[spSugHist.length-1]];
  var pool=SP_NAMES.filter(function(n){ return n!==cur&&last4.indexOf(n)<0&&!(lastStory&&SP_STORY_NAMES[n]); }), n=pool[Math.floor(Math.random()*pool.length)];
  spSugHist.push(n); el.value=n; el.focus(); try{ el.select(); }catch(e){} spTrack('sp_name_suggested',{}); }
function whyPage(b){
  if(!b.story) return '';
  return '<div class="page-inner" style="padding:0"><div class="sp-endpg'+(spST?' mailing':'')+'">' + ORN +
    (D.setImg ? '<div class="plate"><img src="'+esc(D.setImg)+'" alt="'+esc(D.setAlt)+'"></div>' : '') +
    '<div class="cap">'+D.caption+'</div>' +
    '<h3>Build this story with these tiles</h3>' +
    '<p class="lay">Lay them on the floor, and the story can go a new way every time.</p>' +
    '<div class="price">'+esc(D.price)+(D.priceNote?'<small>'+D.priceNote+'</small>':'')+'</div>' +
    '<button class="btn" type="button" data-both="tiles">Make this story for me</button>' +
    (D.showPlay ? '<a class="play" href="'+esc(D.playUrl)+'">Play it in the game first ›</a>' : '') +
    (D.showMail && !spST ? '<button class="sp-mailopen" type="button">Or email me their story, free ›</button>' : '') +
    (D.showMail || spST ? '<form class="sp-mail"'+(spST?'':' hidden')+' novalidate>' +
      '<div class="mh">Their story, with their name on every page</div>' +
      '<input name="child" autocomplete="off" maxlength="40" placeholder="Their name" aria-label="Their name">' +
      (spST ? '<button class="sp-suggest" type="button" style=\''+SP_LINK+'\'>Suggest a name</button>' : '') +
      '<input name="email" type="email" autocomplete="email" placeholder="Your email" aria-label="Your email"'+(spST?' hidden':'')+'>' +
      (spST ? '<div class="mf big sp-to">We’ll send it to the address we emailed you at. <button class="sp-otheraddr" type="button" style=\''+SP_LINK+'\'>Use a different address</button></div>' : '') +
      '<button class="btn sp-mailgo" type="submit">Send me their story</button>' +
      '<div class="mf">'+esc(D.consentText)+'</div>' +
    '</form>' : '') +
    '<div class="colo">Made to order in Wiltshire · posted from 1 December</div>' +
    '</div></div>';
}
var spBaseBuild=buildPages;
buildPages=function(b){
  if(!b.story) return spBaseBuild(b);
  var p=[spEndpaper(true), spTitlePage(b)];
  (b.interior||[]).forEach(function(x){ p.push(insidePage(x)); });
  p.push(spTheEnd()); p.push(whyPage(b));
  return p;
};

/* ---- phones (max-width 749px): one spread per screen, the drawing with its words beneath. The same one-up reader turns it (osbTuck: tap, swipe, the corner, the arrow keys).
   Nothing here runs above 749px: buildPages hands desktop straight to the split pages, and the observer is only installed on a phone build. (mobile-reader, 2 Nov 2026) ---- */
var spPhoneMQ=window.matchMedia?matchMedia('(max-width:749px)'):null;
function spPhone(){ return !!(spPhoneMQ&&spPhoneMQ.matches); }
function spSpread(art,name,words,n,verse){ return {html:'<div class="sp-spread"><div class="sp-art">'+art+'</div><div class="sp-capline"><span class="cap">'+esc(name)+'</span><span class="pno">'+(n+1)+'</span></div><div class="sp-text'+(verse?' verse':'')+'">'+words+'</div></div>'}; }
var interiorPhone=[], interiorPoemPhone=[];
Array.prototype.forEach.call(document.querySelectorAll('#spStoryText .sp-story-page'),function(s,n){
  var fig=s.querySelector('.sp-story-fig'), art=fig?fig.innerHTML:'', name=s.getAttribute('data-name')||'';
  var paras=Array.prototype.map.call(s.querySelectorAll('p'),function(p,j){ return '<p'+(n===0&&j===0?' class="drop"':'')+'>'+p.innerHTML+'</p>'; }).join('');
  interiorPhone.push(spSpread(art,name,paras,n,false));
  if(D.hasPoem && verses[n]){ var v=verses[n].querySelector('.verse'); interiorPoemPhone.push(spSpread(art,name,'<p>'+(v?v.innerHTML:'')+'</p>',n,true)); }
});
/* the fit: the drawing has already given way to its minimum (CSS); if the words still overflow, 18px -> 17px -> 16px; then, and only then, the drawing goes */
function spOver(el){ return el.scrollHeight>el.clientHeight+1; }
function spFit(el){ el.classList.remove('sp-f17','sp-f16','sp-f0'); if(!spOver(el)) return; el.classList.add('sp-f17'); if(!spOver(el)) return; el.classList.remove('sp-f17'); el.classList.add('sp-f16'); if(!spOver(el)) return; el.classList.add('sp-f0'); }
function spFitAll(){ if(!spPhone()) return; Array.prototype.forEach.call(bookOpen.querySelectorAll('.sp-spread'),spFit); }
var spPhoneReady=false;
function spPhoneInit(){ if(spPhoneReady) return; spPhoneReady=true;
  new MutationObserver(spFitAll).observe(bookOpen,{childList:true,subtree:true});   /* every render and every prep: the page under the leaf is fitted before it is seen */
  window.addEventListener('resize',spFitAll); }
var spSplitBuild=buildPages;
buildPages=function(b){
  if(!b.story||!spPhone()) return spSplitBuild(b);
  spPhoneInit();
  var p=[spEndpaper(true), spTitlePage(b)];
  (spMode==='poem'?interiorPoemPhone:interiorPhone).forEach(function(x){ p.push(insidePage(x)); });
  p.push(spTheEnd()); p.push(whyPage(b));
  return p;
};
/* crossing 749px (a tablet turned, a window resized): rebuild the pages and keep the place. split: art 2+2n, words 3+2n; phone: 2+n */
if(spPhoneMQ){ var spOnMQ=function(){ if(!currentKey||!BOOKS[currentKey].story) return; var S=interiorPhone.length, n=i, m;
    if(spPhone()){ m = n<2 ? n : (n<2+2*S ? 2+Math.floor((n-2)/2) : n-S); } else { m = n<2 ? n : (n<2+S ? 2+2*(n-2) : n+S); }
    PAGES=buildPages(BOOKS[currentKey]); i=Math.max(0,Math.min(PAGES.length-1,m)); render(); };
  if(spPhoneMQ.addEventListener) spPhoneMQ.addEventListener('change',spOnMQ); else if(spPhoneMQ.addListener) spPhoneMQ.addListener(spOnMQ); }

/* ---- tracking: the store's own tracker at once; the pixel and GA4 when they are live (consent given). Never a name, only its length. ---- */
function spTrack(name,params){
  try{ if(window.__OS_TRACK__) window.__OS_TRACK__(name,{'ep.os_detail':JSON.stringify(params)}); }catch(e){}
  try{ if(window.fbq&&fbq.callMethod) fbq('trackCustom',name,params); }catch(e){}
  try{ if(window.gtag) gtag('event',name,params); }catch(e){}
}
function spToast(t){ if(!t) return; try{ document.getElementById('live').textContent=t; }catch(e){} var x=document.getElementById('spToast'); if(!x){ x=document.createElement('div'); x.id='spToast'; x.style.cssText='position:fixed;left:50%;bottom:44px;transform:translateX(-50%);z-index:1090;background:#fff1d3;color:#2a1a06;font:14px Questrial,sans-serif;padding:10px 16px;max-width:calc(100vw - 32px);box-shadow:0 10px 30px rgba(0,0,0,.4)'; document.body.appendChild(x);} x.textContent=t; x.hidden=false; clearTimeout(spToast.t); spToast.t=setTimeout(function(){x.hidden=true;},3800); }

/* ---- "Make this story for me": the plain bookends and this story's tiles, then straight to the checkout ---- */
function spMakeIt(btn){
  if(spMakeIt.busy) return; spMakeIt.busy=true;
  var items=D.variants.map(function(id){ return {id:id, quantity:1}; });
  var label=btn?btn.textContent:''; if(btn){ btn.disabled=true; btn.textContent='Making it…'; }
  spTrack('sp_story_add_click',{story:D.handle,lines:items.length,value:D.value});
  fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){ if(!r.ok) return r.text().then(function(t){ throw {status:r.status,body:t}; }); return r.json(); })
    .then(function(){ spTrack('sp_story_add',{story:D.handle,lines:items.length,value:D.value,to:'checkout'}); location.href='/checkout'; })
    .catch(function(e){ spMakeIt.busy=false; spTrack('sp_story_add_error',{story:D.handle,status:(e&&e.status)||0}); if(btn){ btn.disabled=false; btn.textContent=label||'Make this story for me'; } spToast('Something got in the way. Please try once more.'); });
}
var pageBtn=document.getElementById('spMakeBtn'); if(pageBtn) pageBtn.addEventListener('click',function(){ spMakeIt(pageBtn); });

/* ---- the free story by email: typing and tapping in the form never turns the page ---- */
function spCookie(n){ try{ var m=document.cookie.match(new RegExp('(?:^|; )'+n+'=([^;]*)')); return m?decodeURIComponent(m[1]):null; }catch(e){ return null; } }
function spUuid(){ try{ if(crypto.randomUUID) return crypto.randomUUID(); }catch(e){} return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){ var r=Math.random()*16|0; return (c==='x'?r:(r&3|8)).toString(16); }); }
function spMail(f){
  var nameEl=f.querySelector('[name=child]'), mailEl=f.querySelector('[name=email]'), go=f.querySelector('.sp-mailgo');
  var n=(nameEl.value||'').trim(), m=(mailEl.value||'').trim();
  if(!/^[A-Za-zÀ-ɏ][A-Za-zÀ-ɏ' \-]{0,39}$/.test(n)){ nameEl.focus(); spToast(n?'Just their first name, letters only.':'Tell us their name, and it goes on every page.'); return; }
  var viaST=!!spST&&mailEl.hidden;
  if(!viaST&&!/^\S+@\S+\.\S+$/.test(m)){ mailEl.focus(); spToast('That email address doesn’t look quite right.'); return; }
  var eid=spUuid(); go.disabled=true; go.textContent='Sending…';
  if(!viaST){ try{ if(window.fbq&&fbq.callMethod) fbq('track','Lead',{content_name:'story-pdf:'+D.handle},{eventID:eid}); }catch(e){} }
  spTrack('sp_story_pdf_submit',{story:D.handle,name_len:n.length});
  var reset=function(){ go.disabled=false; go.textContent='Send me their story'; };
  fetch(D.pdfEndpoint,{method:'POST',headers:{'Content-Type':'application/json'},keepalive:true,body:JSON.stringify({child:n,email:viaST?undefined:m,st:viaST?spST:undefined,story:D.handle,pageUrl:location.href.replace(/([?&])st=[^&#]*&?/,'$1').replace(/[?&](#|$)/,'$1'),consentText:D.consentText,eventId:eid,fbp:spCookie('_fbp'),fbc:spCookie('_fbc')})})
    .then(function(r){ return r.json().catch(function(){ return {}; }).then(function(j){ return {status:r.status,j:j}; }); })
    .then(function(x){
      if(x.status>=200&&x.status<300&&x.j.ok!==false){ var r=f.getBoundingClientRect(); spBurst(r.left+r.width/2,r.top+r.height/2,30); f.innerHTML='<div class="mh">On its way</div><div class="mf big">'+esc(n)+'’s story is on its way to '+(viaST?'your inbox':esc(m))+'.</div>'; spTrack('sp_story_pdf_sent',{story:D.handle}); return; }
      reset();
      if(x.status===400&&x.j.field==='email'&&viaST) spOtherAddr(f);
      if(x.status===400&&x.j.message){ spToast(x.j.message); var fe=f.querySelector('[name='+(x.j.field==='child'?'child':'email')+']'); if(fe) fe.focus(); return; }
      if(x.status===429){ spToast(x.j.message||'Give it a minute, then try again.'); return; }
      spToast('Something got in the way. Please try once more.');
    })
    .catch(function(){ reset(); spToast('Something got in the way. Please try once more.'); });
}
function spOtherAddr(f){ var m=f.querySelector('[name=email]'); if(m){ m.hidden=false; m.focus(); } var t=f.querySelector('.sp-to'); if(t) t.hidden=true; }
(function(){
  var bk=document.getElementById('bookOpen');
  ['click','pointerdown','pointermove','pointerup','touchstart','touchmove','touchend'].forEach(function(ev){
    bk.addEventListener(ev, function(e){
      if(!e.target.closest('.sp-mail,.sp-mailopen,.play,.sp-modelink')) return;
      e.stopImmediatePropagation();
      if(ev!=='click') return;
      var sg=e.target.closest('.sp-suggest'); if(sg){ e.preventDefault(); spSuggest(sg.closest('.sp-mail')); return; }
      var oa=e.target.closest('.sp-otheraddr'); if(oa){ e.preventDefault(); spOtherAddr(oa.closest('.sp-mail')); return; }
      var ml=e.target.closest('.sp-modelink'); if(ml){ e.preventDefault(); spSetMode(spMode==='poem'?'story':'poem'); return; }
      var opener=e.target.closest('.sp-mailopen');
      if(opener){ var pg=opener.closest('.sp-endpg'); pg.classList.add('mailing'); opener.hidden=true; var f=pg.querySelector('.sp-mail'); f.hidden=false; spTrack('sp_story_pdf_open',{story:D.handle}); setTimeout(function(){ f.querySelector('input').focus(); },30); }
      if(e.target.closest('.play')) spTrack('sp_story_play_click',{story:D.handle});
    }, true);
  });
  bk.addEventListener('submit', function(e){ var f=e.target.closest('.sp-mail'); if(!f) return; e.preventDefault(); spMail(f); });
  document.addEventListener('keydown', function(e){ if(e.target.closest && e.target.closest('.sp-mail')) e.stopImmediatePropagation(); }, true);
  if(spST) spTrack('sp_story_pdf_open',{story:D.handle,via:'email'});
})();

/* ---- the surface: motes, sparkles on each turn, a unicorn now and then ---- */
(function(){ if(spReduce) return; var cv=document.getElementById('spMotes'); if(!cv) return; var cx=cv.getContext('2d'), dpr=Math.min(2,devicePixelRatio||1), m=[];
  function size(){cv.width=cv.clientWidth*dpr; cv.height=cv.clientHeight*dpr;} addEventListener('resize',size); setTimeout(size,50);
  /* 2 Nov: the living hub's drift law (see sp-stories-hub): px per 16.67 ms frame, delta-timed, capped at 3 frames; the motes hang in the light instead of racing. */
  for(var k=0;k<30;k++) m.push({x:Math.random(),y:Math.random(),r:.6+Math.random()*1.8,vx:-.13+Math.random()*.26,vy:-.09+Math.random()*.14,p:Math.random()*6.28});
  var last=0;
  (function loop(t){ if(!panel.classList.contains('open')){ last=0; requestAnimationFrame(loop); return; } var W=cv.width,H=cv.height, dt=last?Math.min((t-last)/16.67,3):1; last=t; cx.clearRect(0,0,W,H);
    m.forEach(function(o){ o.y+=o.vy*dt*dpr/H; o.x+=(o.vx*dt*dpr+Math.sin(t/2400+o.p)*.18*dt)/W; if(o.y<-.05){o.y=1.05;o.x=Math.random();} if(o.y>1.05){o.y=-.05;o.x=Math.random();} if(o.x<-.05)o.x=1.05; if(o.x>1.05)o.x=-.05;
      var a=.35+.6*Math.abs(Math.sin(t/900+o.p)), X=o.x*W, Y=o.y*H, R=o.r*dpr*5, g=cx.createRadialGradient(X,Y,0,X,Y,R);
      g.addColorStop(0,'rgba(255,226,150,'+a+')'); g.addColorStop(.25,'rgba(255,196,90,'+(a*.45)+')'); g.addColorStop(1,'rgba(255,190,80,0)');
      cx.fillStyle=g; cx.beginPath(); cx.arc(X,Y,R,0,6.283); cx.fill(); });
    requestAnimationFrame(loop); })(0);
})();
var spS=[], spC=document.getElementById('spSpark'), spX=spC.getContext('2d'), spD=Math.min(2,devicePixelRatio||1), spRun=false;
function spSize(){spC.width=innerWidth*spD; spC.height=innerHeight*spD;} spSize(); addEventListener('resize',spSize);
function spBurst(x,y,n){ if(spReduce) return; for(var k=0;k<n;k++){var a=Math.random()*6.283, v=.8+Math.random()*2.6; spS.push({x:x,y:y,vx:Math.cos(a)*v,vy:Math.sin(a)*v-1,l:1,r:1.6+Math.random()*3.6,ro:Math.random()*3});} if(!spRun){spRun=true; requestAnimationFrame(spLoop);} }
function spStar(p){ spX.save(); spX.translate(p.x*spD,p.y*spD); spX.rotate(p.ro); spX.globalAlpha=Math.max(0,p.l); var r=p.r*spD, g=spX.createRadialGradient(0,0,0,0,0,r*2.4); g.addColorStop(0,'rgba(255,246,210,1)'); g.addColorStop(.4,'rgba(255,214,120,.9)'); g.addColorStop(1,'rgba(255,190,80,0)'); spX.fillStyle=g; spX.beginPath(); for(var q=0;q<8;q++){var rr=q%2?r*.28:r*2.2, aa=q*Math.PI/4; spX.lineTo(Math.cos(aa)*rr,Math.sin(aa)*rr);} spX.closePath(); spX.fill(); spX.restore(); }
function spLoop(){ spX.clearRect(0,0,spC.width,spC.height); spS=spS.filter(function(p){p.x+=p.vx;p.y+=p.vy;p.vy+=.045;p.vx*=.985;p.l-=.02;p.ro+=.08; if(p.l>0) spStar(p); return p.l>0;}); if(spS.length) requestAnimationFrame(spLoop); else spRun=false; }
var spTurns=0;
new MutationObserver(function(){
  var r=document.getElementById('bookOpen').getBoundingClientRect(); if(!r.width) return;
  spTurns++;
  var edge = twoUp() ? r.left + r.width/2 : r.left + r.width*.15;
  for(var k=0;k<3;k++) (function(k){ setTimeout(function(){ spBurst(edge + (Math.random()-.5)*40, r.top + r.height*(.2+Math.random()*.6), 7); }, k*90); })(k);
  if(spTurns===3 || spTurns===7 || (spTurns>7 && spTurns%5===0)) spTrot();
  if(i+1>=PAGES.length && !spTrack.ended){ spTrack.ended=true; spTrack('sp_story_end',{story:D.handle,turns:spTurns}); }
}).observe(document.getElementById('rbCount'), {childList:true, characterData:true, subtree:true});
function spTrot(){ if(spReduce) return; var u=document.getElementById('spTrot'); if(!u) return; u.classList.remove('go'); void u.offsetWidth; u.classList.add('go');
  var r=document.getElementById('bookOpen').getBoundingClientRect(); var t0=performance.now();
  (function glint(t){ var k=(t-t0)/4200; if(k>1) return; var x=r.left + r.width*(.96 - 1.04*k); spBurst(x+20, r.bottom - r.height*.08, 1); setTimeout(function(){requestAnimationFrame(glint);},160); })(t0); }

/* ---- the closed cover: tap, click, Enter or a swipe opens it ---- */
var spBook=document.getElementById('bookOpen'), spCov=document.getElementById('spCover');
function spOpenCover(){ if(!spBook.classList.contains('sp-closed')) return;
  spBook.classList.remove('sp-closed'); spBook.classList.add('sp-opened');
  setTimeout(function(){ spBook.classList.add('sp-half'); }, spReduce ? 0 : 520);
  spTrack('sp_story_open',{story:D.handle});
  var r=spBook.getBoundingClientRect(); setTimeout(function(){ spBurst(r.left+r.width/2, r.top+r.height/2, 34); }, 700); setTimeout(spTrot, 1700); }
function spShut(){ spBook.classList.remove('sp-opened','sp-half'); spBook.classList.add('sp-closed'); }
spCov.addEventListener('click', function(e){ e.stopPropagation(); spOpenCover(); });
spCov.addEventListener('pointerdown', function(e){ e.stopPropagation(); });
spCov.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '||e.key==='ArrowRight'){ e.preventDefault(); e.stopPropagation(); spOpenCover(); } });
document.addEventListener('keydown', function(e){ if(panel.classList.contains('open') && spBook.classList.contains('sp-closed') && e.key==='ArrowRight'){ e.stopImmediatePropagation(); spOpenCover(); } }, true);

/* ---- closing puts the book back and shows the page beneath; the page's button opens it again ---- */
function spClosed(){ spTrack('sp_story_close',{story:D.handle,turns:spTurns}); document.body.classList.remove('sp-reading'); }
var reopen=document.getElementById('spOpenBook'); if(reopen) reopen.addEventListener('click', function(){ spShut(); openBook(D.handle); document.body.classList.add('sp-reading'); });
/* open on load, closed, ready to be opened */
spTrack('sp_story_land',{story:D.handle,ref:document.referrer?document.referrer.replace(/^https?:\/\//,'').split('/')[0]:''});
openBook(D.handle); document.body.classList.add('sp-reading');
})();
